import clsx from 'clsx';
import { useState } from 'react';
import ContainerCard from '../../../../common/components/ContainerCard';
import { useAppDispatch, useAppSelector } from '../../../../common/hooks';
import { IPhone } from '../../../../models/Account/IPhone';
import { RootState } from '../../../../redux/store';
import styles2 from '../../AccountPage.module.css';
import PhoneModal from './components/PhoneModal';
import PhoneNumberCard from './components/PhoneNumberCard';
import styles from './PhoneNumbersSection.module.css';
import { setContactConfig } from '../../../../redux/accountSlice';

type PhoneProps = {
  phoneNumbers: IPhone[];
  onAddPhone: (newPhone: IPhone) => Promise<unknown>;
  onUpdatePhone: (phone: IPhone) => Promise<unknown>;
  onDeletePhone: (phone: IPhone) => void;
  onChangeCountry: (countryCode: string) => Promise<unknown>;
};

const PhoneNumbersSection = (props: PhoneProps) => {
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [existingPhone, setExistingPhone] = useState<IPhone>({} as IPhone);
  const [editMode, setEditMode] = useState(false);
  const dispatch = useAppDispatch();
  const togglePhoneModal = () => {
    setShowPhoneModal(!showPhoneModal);
  };

  const onAddEditPhone = (phone: IPhone) => {
    if (editMode) {
      return props.onUpdatePhone(phone);
    } else {
      return props.onAddPhone(phone);
    }
  };

  const doesLocationExist = (location: string) => {
    const locationId = Number(location);
    if (locationId && locationId > 0)
      return props.phoneNumbers?.findIndex(x => x.contactLocation === locationId) >= 0;
    else return false;
  };

  const contactEditData = useAppSelector(
    (state: RootState) => state.accountReducer.contactEditData
  );

  const contactConfigData = useAppSelector(
    (state: RootState) => state.accountReducer.contactConfigData
  );

  const allLocationsExist = () => {
    return contactEditData?.contactLocations.every(
      item => Number(item.value) === 0 || doesLocationExist(item.value)
    );
  };

  const handlePhoneAdd = () => {
    if (!allLocationsExist()) {
      setExistingPhone({
        phoneCode: 'US',
      } as IPhone);
      setShowPhoneModal(!showPhoneModal);
      setEditMode(false);
    }
  };

  const handlePhoneEdit = async (phone: IPhone) => {
    setExistingPhone(phone);
    setShowPhoneModal(!showPhoneModal);
    setEditMode(true);
  };

  const onChangeCountry = (countryCode: string) => {
    return props.onChangeCountry(countryCode);
  };

  const handlePhoneDelete = (phone: IPhone) => {
    props.onDeletePhone(phone);
  };

  return (
    <>
      {showPhoneModal && (
        <PhoneModal
          existingPhone={existingPhone}
          phones={props.phoneNumbers}
          phoneModalClose={togglePhoneModal}
          onAddEditPhone={onAddEditPhone}
          onChangeCountry={onChangeCountry}
          editMode={editMode}
        />
      )}

      <ContainerCard className={styles2.cardDimensions + ' ' + styles2.cardStrech}>
        <div className={styles.title}>PHONE NUMBERS</div>
        <div className={styles.phonesCardContainer}>
          {props.phoneNumbers?.map((phoneNumber, index) => {
            return (
              <PhoneNumberCard
                key={index}
                phoneData={phoneNumber}
                onEdit={handlePhoneEdit}
                onDelete={handlePhoneDelete}
              />
            );
          })}
          <ContainerCard className={styles.plusCardDimensions}>
            <div
              className={clsx(
                styles.centralContainer,
                allLocationsExist() && styles.centralContainerDisabled
              )}
              onClick={handlePhoneAdd}
            >
              <div className={styles.plusSign} />
              <div className={styles.labelBig}>Add New</div>
            </div>
          </ContainerCard>
        </div>
      </ContainerCard>
    </>
  );
};

export default PhoneNumbersSection;
